import React, { useState, useEffect, useRef } from "react";
import "./Login.css";

export default function Login() {
  const [activeModal, setActiveModal] = useState(null);
  const modalRef = useRef(null);

  // Close modal if clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (activeModal && modalRef.current && !modalRef.current.contains(e.target)) {
        setActiveModal(null);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [activeModal]);

  const modalContent = {
    contact: "اینجا می‌توانید اطلاعات تماس با ما را مشاهده کنید...",
    about: "مِمورا یک پلتفرم هوشمند برای یادگیری روان‌پزشکی است که با استفاده از فلش‌کارت‌ها، یادگیری را سریع، موثر و جذاب می‌کند. هدف ما این است که دانشجویان و علاقه‌مندان به روان‌پزشکی بتوانند مطالب را به شکل سازمان‌دهی شده و به‌یادماندنی یاد بگیرند و در زمان خود صرفه‌جویی کنند",
    privacy: " ما به حریم خصوصی کاربران خود احترام می‌گذاریم و اطلاعات شخصی شما را بدون اجازه شما با کسی به اشتراک نمی‌گذاریم. حریم خصوصی شما برای ما مهم است و اطلاعات شما محافظت می‌شوند",
    terms: "تمام محتوای ارائه شده در مِمورا، شامل فلش‌کارت‌ها، تصاویر، متن‌ها و طراحی‌ها، تحت حقوق نشر سایت قرار دارند و استفاده بدون اجازه کتبی از آنها ممنوع است. کپی‌برداری یا توزیع محتوای سایت بدون مجوز قانونی، پیگرد قانونی دارد"
  };

  useEffect(() => {
    const container = document.getElementById("telegram-login");
    container.innerHTML = ""; // clear
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?15";
    script.async = true;
    script.setAttribute("data-telegram-login", "MemuraLogin_bot"); // without @
    script.setAttribute("data-size", "large");
    // IMPORTANT: data-auth-url must point to your backend auth endpoint
    const API_BASE = process.env.REACT_APP_API_URL || "";
    script.setAttribute("data-auth-url", 'https://memuratelegram2.onrender.com/api/auth/telegram/');
    script.setAttribute("data-request-access", "write");
    container.appendChild(script);
  }, []);

  return (
    <div className="login-container">
      <img src="/logoslogan.png" alt="Memura Logo" className="login-logo" />
      <h2 className="login-title">ورود با تلگرام</h2>
      <div id="telegram-login"></div>
      <p className="login-description">
        ویجت ورود با تلگرام یک روش امن با احترام به حریم خصوصی، برای احراز هویت کاربران است
        <br />
        اگر هنوز سوالی دارید، روی لوگوی تلگرام بزنید.
        <br />
        <a href="https://core.telegram.org/bots/features#web-login" target="_blank" rel="noopener noreferrer">
          <img 
             src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" 
             alt="Telegram" 
             style={{ width: "20px", height: "20px", marginLeft: "5px", verticalAlign: "middle" }}
          />
        </a>
      </p>

      {/* Footer Links */}
      <div className="login-footer">
         <span    className="footer-item"    onClick={(e) => { e.stopPropagation(); setActiveModal("contact"); }}  >    Contact  </span>{" | "}
         <span    className="footer-item"    onClick={(e) => { e.stopPropagation(); setActiveModal("about"); }}  >    About Memura  </span>{" | "}
         <span    className="footer-item"    onClick={(e) => { e.stopPropagation(); setActiveModal("privacy"); }}  >    Privacy Policy  </span>{" | "}
         <span    className="footer-item"    onClick={(e) => { e.stopPropagation(); setActiveModal("terms"); }}  >    Terms of Service & Copyright Notice  </span>
      </div>


      {/* Modal */}
      {activeModal && (
        <div className="modal fade-in">
          <div className="modal-content" ref={modalRef}>
            {modalContent[activeModal]}
          </div>
        </div>
      )}
    </div>
  );
}
